/* PW v94.8 Make it yours lift: live character counter on text fields.
   The hint ("up to 10 characters") becomes "3 / 10" while typing and turns gold
   within 2 characters of the limit. Year fields (4 digits) keep their hint.
   The limit is read live from maxlength at each keystroke, and the original hint is
   captured on first input, because preview scripts (mugs) rewrite both after load. */
(function () {
  function init(input) {
    if (input.dataset.pwLift) return;
    input.dataset.pwLift = '1';
    if (input.getAttribute('inputmode') === 'numeric') return;
    var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    var hint = label && label.querySelector('.pw-mky__max');
    if (!hint) return;
    var orig = null;
    hint.setAttribute('aria-live', 'polite');
    function upd() {
      var max = input.maxLength;
      if (!max || max < 1) return;
      var n = input.value.length;
      if (!n) {
        if (orig !== null) hint.textContent = orig;
        hint.classList.remove('is-near', 'is-full');
        return;
      }
      if (orig === null) orig = hint.textContent;
      hint.textContent = n + ' / ' + max;
      hint.classList.toggle('is-full', n >= max);
      hint.classList.toggle('is-near', n < max && n >= Math.max(1, max - 2));
    }
    input.addEventListener('input', upd);
    if (input.value) upd();
  }
  function run() {
    var list = document.querySelectorAll('.pw-mky .pw-mky__input');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
